import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { IPaginatedQuery } from '@monorepo/components';

import { getAllFaqsById, getAllFaqsCategory } from '../requests/faq.requests';

export const useGetAllFaqsById = (query: IPaginatedQuery) =>
  useInfiniteQuery({
    queryKey: ['faqs', query],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await getAllFaqsById({ ...query, page: pageParam });
      return res.data;
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage.pagination) return undefined;
      const nextPage = Number(lastPage.pagination.currentPage) + 1;
      const total = lastPage.pagination.totalPages;

      return nextPage <= total ? nextPage : undefined;
    },
    initialPageParam: 1,
  });

export const useGetAllFaqsCategory = () =>
  useQuery({
    queryKey: ['faqs-category'],
    queryFn: async () => {
      const res = await getAllFaqsCategory();
      return res.data;
    },
  });
